import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const filters = (accountOptions = []) => [
  {
    title: 'تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',

    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
];

export default filters;

const STATUS_OPTIONS = [
  {
    label: 'تنخواه دار',
    value: 'تنخواه گردان',
  },
  {
    label: 'تنخواه گردان',
    value: 'شعبه',
  },
];
